module.exports = __webpack_public_path__ + "static/media/gas_cylinder_2.e6f84589.svg";